export default {
  buttons: {
    sign_in: 'Kirjaudu sisään',
    sign_up: 'Luo tili',
    logout: 'Kirjaudu ulos',
  },
  logout_confirm: {
    title: 'Kirjaudutaanko ulos?',
    description: 'Haluatko varmasti kirjautua ulos?',
    cancel: 'Peruuta',
    confirm: 'Kirjaudu ulos',
  },
};
